var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropertiesLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8702 0.88318L10.7793 0.809955L10.686 0.8801L0.909866 8.22925L0.85 8.27425V8.34915V40.9998V41.1498H1H19.911H20.061V40.9998V8.35758V8.28579L20.0051 8.24076L10.8702 0.88318ZM18.9388 40.0357H1.97222V8.82807L10.7554 2.22535L18.9388 8.81653V40.0357Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2111 14.1008H16.3611V13.9508V13.1367V12.9867H16.2111H12.9222H12.7722V13.1367V13.9508V14.1008H12.9222H16.2111Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98882 14.1008H8.13882V13.9508V13.1367V12.9867H7.98882H4.69995H4.54995V13.1367V13.9508V14.1008H4.69995H7.98882Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2111 21.2053H16.3611V21.0553V20.2412V20.0912H16.2111H12.9222H12.7722V20.2412V21.0553V21.2053H12.9222H16.2111Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2111 28.3098H16.3611V28.1598V27.3457V27.1957H16.2111H12.9222H12.7722V27.3457V28.1598V28.3098H12.9222H16.2111Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2111 35.4143H16.3611V35.2643V34.4502V34.3002H16.2111H12.9222H12.7722V34.4502V35.2643V35.4143H12.9222H16.2111Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98882 21.2053H8.13882V21.0553V20.2412V20.0912H7.98882H4.69995H4.54995V20.2412V21.0553V21.2053H4.69995H7.98882Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98882 28.3098H8.13882V28.1598V27.3457V27.1957H7.98882H4.69995H4.54995V27.3457V28.1598V28.3098H4.69995H7.98882Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98882 35.4143H8.13882V35.2643V34.4502V34.3002H7.98882H4.69995H4.54995V34.4502V35.2643V35.4143H4.69995H7.98882Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2564 40.5936V40.7436H10.4064H11.2286H11.3786V40.5936V1.51855V1.36855H11.2286H10.4064H10.2564V1.51855V40.5936Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0889 16.9457H18.9389V17.0957V40.9996V41.1496H19.0889H37.9999H38.1499V40.9996V17.0957V16.9457H37.9999H19.0889ZM37.0277 40.0355H20.0611V18.0598H37.0277V40.0355Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6391 26.3841L22.6391 26.5341L22.7891 26.5341L23.6113 26.5341L23.7613 26.5341L23.7613 26.3841L23.7613 21.0557L23.7613 20.9057L23.6113 20.9057L22.7891 20.9057L22.6391 20.9057L22.6391 21.0557L22.6391 26.3841Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5717 26.3841L27.5717 26.5341L27.7217 26.5341L28.5439 26.5341L28.6939 26.5341L28.6939 26.3841L28.6939 21.0557L28.6939 20.9057L28.5439 20.9057L27.7217 20.9057L27.5717 20.9057L27.5717 21.0557L27.5717 26.3841Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5053 26.3841L32.5053 26.5341L32.6553 26.5341L33.4775 26.5341L33.6275 26.5341L33.6275 26.3841L33.6275 21.0557L33.6275 20.9057L33.4775 20.9057L32.6553 20.9057L32.5053 20.9057L32.5053 21.0557L32.5053 26.3841Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6391 35.2649L22.6391 35.4149L22.7891 35.4149L23.6113 35.4149L23.7613 35.4149L23.7613 35.2649L23.7613 29.9365L23.7613 29.7865L23.6113 29.7865L22.7891 29.7865L22.6391 29.7865L22.6391 29.9365L22.6391 35.2649Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5717 35.2649L27.5717 35.4149L27.7217 35.4149L28.5439 35.4149L28.6939 35.4149L28.6939 35.2649L28.6939 29.9365L28.6939 29.7865L28.5439 29.7865L27.7217 29.7865L27.5717 29.7865L27.5717 29.9365L27.5717 35.2649Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5053 35.2649L32.5053 35.4149L32.6553 35.4149L33.4775 35.4149L33.6275 35.4149L33.6275 35.2649L33.6275 29.9365L33.6275 29.7865L33.4775 29.7865L32.6553 29.7865L32.5053 29.7865L32.5053 29.9365L32.5053 35.2649Z",
    fill: "#2D2943",
    stroke: "#2D2943",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertiesLarge);
export default __webpack_public_path__ + "static/media/properties-large.92a77dc9.svg";
export { ForwardRef as ReactComponent };